<div fxFlex="column" class="release-all-dialog">

    <div class="dialog-header">
        Release All - {{ title }}
    </div>

    <div  class="release-all-container" fxLayout="column">
        

        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="45" class="form-key">
                Reassign if below Threshold :
            </div>
            <div fxFlex="45">
                <mat-slide-toggle [(ngModel)]="reassign" class="slide-toggle"></mat-slide-toggle>
            </div>
        </div>

        <div *ngIf="reassign">
            Scores above or equal to the threshold will be released. Scores below the threshold will be reassigned.
        </div>

        <div *ngIf="reassign" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="50" class="form-key">
                Threshold :
            </div> 
            <div fxFlex="45">
                <mat-form-field class="full-width">
                    <input type="number" matInput [formControl]="thresholdControl" (keyup)="onThresholdChange($event.target.value)" (click)="onThresholdChange($event.target.value)">
                  </mat-form-field>
            </div>
        </div>

        <div [hidden]="!thresholdControl.valid" fxLayout="row" fxLayoutAlign="space-between center" class="my-20">
            <div fxFlex="50" class="form-key">
                Release :
                <span class="form-value">
                    {{ releaseCount + ' ' + type }}
                </span>
            </div>
            <div *ngIf="reassign" fxFlex="45" class="form-key">
                Reassign :
                <span class="form-value">
                    {{ reassignCount + ' ' + type }}
                </span>
            </div>
        </div>

        <div *ngIf="reassign" class="reassign-container" fxLayout="column">
          <div class="reassign-question">
              Should the student see an icon indicating the questions he/she got incorrect on the previous attempt?
          </div>
          <mat-radio-group class="reassign-selection" [(ngModel)]="selectedReassignOption" (change)="onReassignChange($event)" aria-label="Select an Option">
              <div fxLayout="column">
                  <mat-radio-button class="reassign-option" [value]="true" (click)="onRadioClicked($event)">
                      Yes
                  </mat-radio-button>
                  <mat-checkbox class="sub-selection" [(ngModel)]="subYes" [disabled]="selectedReassignOption == undefined || !selectedReassignOption">
                      Student can see his/her responses to the questions that were incorrect.
                  </mat-checkbox>
              </div>
              <div fxLayout="column">
                  <mat-radio-button class="reassign-option" [value]="false" (click)="onRadioClicked($event)">
                      No
                  </mat-radio-button>
                  <mat-checkbox class="sub-selection" [(ngModel)]="subNo" [disabled]="selectedReassignOption == undefined || selectedReassignOption">
                      Allow the student to see his/her previous answers.
                  </mat-checkbox>
              </div>
          </mat-radio-group>
      </div>

        <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
            <div>
                <button
                    class="cancel-button button"
                    mat-button
                    type="button"
                    (click)="onCancel()"
                >
                    Cancel
                </button>
            </div>
            <div>
                <button
                [disabled]="!thresholdControl.valid"
                class="submit-button button"
                mat-button
                type="button"
                (click)="onReleaseAll()"
            >
                Release All
            </button>
            </div>
        </div>
    </div>
</div>
